<template>
  <div class="order">
    <div style="margin: 10px">
      <div class="header">
        <div class="name">{{ workOrder.woTitle }}</div>
        <div class="time">{{ formDate(workOrder.createTime) }}</div>
      </div>
      <div class="content">
        <div v-html="workOrder.woContent"></div>
      </div>
      <div class="file" v-if="workOrder.woFileRelVoList">
        <div v-for="file in workOrder.woFileRelVoList">
          <span>{{ file.fileName }}</span>
          <a :href="file.fileUrl">预览</a>
        </div>
      </div>
    </div>
    <div class="border"></div>
    <div class="userInfo">
      <div class="userFile">
        <span class="label">用户名称:</span>
        <span class="value">{{ workOrder.crmCustomerVo.name }}</span>
      </div>
      <div class="userFile">
        <span class="label">用户电话:</span>
        <span class="value">{{ workOrder.crmCustomerVo.phone }}</span>
      </div>
      <div class="userFile" v-for="item in workOrder.cusFieldConfigInfoVoList">
        <span class="label">{{ item.fieldName }}:</span>
        <span class="value">{{ item.fieldValue }}</span>
      </div>
    </div>
    <div class="border"></div>
    <div class="replay">
      <div class="replay_item" v-for="replay in workOrder.handle">
        <div class="name">{{ replay.handleUserName }} （{{ replay.handleType == 2 ? '客户' : '客服' }}）</div>
        <div class="content"><span>{{ replay.handleType == 1 ? '公开回复' : replay.handleType == 2 ? '客户回复' : '内部回复' }}：</span>
          <span v-html="replay.handleContent"></span></div>
        <div class="time">{{ formDate(replay.handleTime) }} </div>
      </div>
    </div>
    <div class="btn">
      <Button class="button" @click="open">回复</Button>
    </div>
    <div class="add_bg" v-if="showModal">
      <div class="add_replay">
        <div class="replay-header">
          <div class="replay-title">回复工单</div>
          <div class="close" @click="closeModal()"></div>
        </div>
        <div class="replay-content">
          <div style="color: #6a6666;margin-bottom: 10px;">回复内容：</div>
          <el-input v-model="content" type="textarea" rows="4" calls="5" placeholder="请输入"> </el-input>
          <el-button class="submit" type="primary" size="small" :disabled="!content" @click="submit">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../api/request";

export default {
  name: "h5",
  data() {
    return {
      workOrder: {},
      showModal: false,
      content: ''
    }
  },
  mounted() {
    let param = {
      id: this.$route.query.woId,
      userId: this.$route.query.userId,
    }
    this.getOrderInfo(param)
  },
  methods: {
    open() {
      this.showModal = true;
      this.content = '';
    },
    getOrderInfo(param) {
      request.getOrderInfo(param).then(result => {
        console.log(result)
        if (result.code === 200) {
          this.workOrder = result.data
        }
      })
    },
    formDate(value, fmt) {
      if (!value) {
        return '--'
      }
      fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
      if (value && value < 10000000000) {
        value = value * 1000;
      }

      let getDate = new Date(value * 1);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
    closeModal() {
      this.showModal = false;
    },
    submit() {
      let param = {
        "handleContent": this.content,
        "woId": this.$route.query.woId
      }
      request.addReplay(param).then(result => {
        if (result.code === 200) {
          this.$message.success('操作成功！');
          this.showModal = false;
          this.getOrderInfo()
        } else {
          this.$message.error(result.message)
        }
      })
    }
  }
}
</script>

<style scoped>
.replay-content {
  padding: 30px 20px;
  color: #e6e6e6;
}

.order .add_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(2, 2, 2, .2);
}

.add_replay {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 350px;
  background: white;
}

.order {
  text-align: left;
  padding: 0.1px;
  height: 100%;
  overflow: auto;
  width: 80%;
  max-width: 800px;
  margin: 0 auto;
}

.order::-webkit-scrollbar {
  width: 0px;
  height: 1px;
}

.order::-webkit-scrollbar-thumb {
  border-radius: 2px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.order::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.order::-webkit-scrollbar-corner {
  border-radius: 2px;
}

.order>div {
  background: white;
}

.header {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px 4px 12px;
}

.name {
  font-size: 20px;
  font-weight: bold;
}

.time {
  color: #666666;
  font-size: 12px;
  margin-top: 10px;
}

.content {
  margin: 15px 0;
}

.content div {
  max-width: 100%;
}

.order .border {
  background: #f4f4f4;
  height: 10px;
}

.file>div {
  font-size: 13px;
  background: #F7F8FA;
  padding: 5px 10px;
  color: #636A7A;
  line-height: 20px;
  margin: 6px 0;
}

.file a {
  float: right;
  color: #98A0AF;
  text-decoration: none;
}

.userInfo {
  padding: 10px;
}

.userFile {
  font-size: 13px;
  line-height: 24px;
  display: flex;
}

.userFile .label {
  display: inline-block;
  max-width: 160px;
  width: auto;
  color: #1d1d1d;
}

.userFile .value {
  flex: 1;
  max-width: 120px;
  color: #4c4c4c;
  margin-right: 5px;
}

.replay {
  /*padding: 10px;*/
}

.replay_item {
  margin: 10px;
  border-bottom: 1px dashed #dcdcdc;
  padding-bottom: 8px;
}

.replay_item .name {
  font-weight: 600;
  color: #636A7A;
  font-size: 14px;
}

.replay_item .content {
  font-size: 14px;
  color: #2A3047;
}

.replay_item .content span {
  color: #6c6c6c;
  font-size: 13px;
}

.replay_item .time {
  color: #98A0AF;
}

.button {
  width: 150px;
  height: 32px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  background: #7467F0
}

.btn {
  text-align: center;
  margin: 20px 0;
}

.close::before {
  content: '\2716'
}

.replay-header {
  height: 22px;
  background: #f3f3f3;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #818181;
}

.submit {
  width: 150px;
  margin: 20px auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/order/pc.vue